import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { DataBridgeService } from '../../services/data-bridge.service';

@Component({
  selector: 'app-plan-builder',
  templateUrl: './plan-builder.component.html',
  styleUrls: ['./plan-builder.component.scss']
})
export class PlanBuilderComponent implements OnInit {
  @Input() FLOOR_DATA;
  @Input() isFloorPlanAvailable;
  @Input() layout;
  @Input() seatID: any;
  @Input() preRenderedPlan: any;
  @Input() empGuid: string;
  @Output() mouseEvent = new EventEmitter<any>();
  @Output() isRendered = new EventEmitter<Boolean>();
  @ViewChild('svgComponent', { static: false }) svgComponent;
  geoJsonData: any;
  floorDetails: any;
  isEmitted: boolean=false;

  floortype: any;
  shouldExecutePolygonFactory: boolean;
  shouldExecuteSVGFactory: boolean;
  shouldExecuteInteractionsInjector: boolean;
  
  constructor(private changeDetectionRef: ChangeDetectorRef) {
  }
  
  ngOnInit() {
    this.geoJsonData = this.layout.geoJson;
    this.floorDetails = this.layout.floorDetails;
    this.floortype = this.floorDetails.floortype;
    if (this.preRenderedPlan && this.isFloorPlanAvailable ) {
        // this.preRenderedPlan.nativeElement.style.filter = "grayscale(1)";
        document.getElementById('planContainer').parentNode.replaceChild(this.preRenderedPlan.nativeElement, document.getElementById('planContainer'));
    }
    else {
        this.shouldExecutePolygonFactory = true;
        this.shouldExecuteSVGFactory = true;
    }
    this.svgComponent = document.getElementById('planContainer');
  }
  
  ngAfterViewInit() { 
    if (this.preRenderedPlan) {
      this.shouldExecuteInteractionsInjector = true;
      this.changeDetectionRef.detectChanges()
    }
  }
  
  finishedSVGInjection(event) {
    this.shouldExecuteInteractionsInjector = true;
    this.changeDetectionRef.detectChanges()
  }
  finishedInteractionsInjection(data) {
    if (!this.isEmitted) {
        this.isEmitted = true;
        this.isRendered.emit(Object.assign({ svgComponent: this.svgComponent }, data));
    }
}


}
